export const postcodeSuburbMapping = (inputData) => {
  //* the input data is the response from the API call to
  //* findSuburb This is what is displayed in the autocomplete
  if (!inputData) return;

  const transformedData = [];

  inputData.forEach((item) => {
    for (const postcode in item) {
      const localityData = item[postcode];
      localityData.forEach((localityItem) => {
        transformedData.push({
          fullPostcode: `${localityItem.postcode} ${localityItem.locality} ${localityItem.state}`,
        });
      });
    }
  });

  return transformedData;
};
